import { FC } from 'react';
import { withDialogSuspenseErrorBoundary } from '@retail/components';
import { Dialog, OutlinedButton } from '@shared/components';
import { DialogContent, DialogTitle } from '@mui/material';
import { Supplier } from '@retail/suppliers/types';
import { usePurchaseAgreementsTFunction } from '@retail/purchase-agreements/i18n';
import { AgreementsWithPriceComparison } from '@retail/purchase-agreements/containers';
import { useDisclosure } from '@shared/hooks';

interface Props {
  assortmentId: number;
  supplier: Supplier;
  open: boolean;
  onClose: () => void;
}

const SupplierAgreementsDialogContainer: FC<Props> = ({
  assortmentId,
  supplier,
  open,
  onClose,
}) => {
  const t = usePurchaseAgreementsTFunction();

  const { isOpen: comparePriceLists, onToggle: toggleComparePriceList } = useDisclosure();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          minHeight: comparePriceLists ? '90%' : undefined,
          maxHeight: comparePriceLists ? '90%' : undefined,
          px: 0,
        },
      }}
    >
      <DialogTitle alignItems="center">
        {t('purchaseAgreements.agreement.agreementsFor', { supplier: supplier.name })}
        <OutlinedButton size="small" sx={{ whiteSpace: 'nowrap' }} onClick={toggleComparePriceList}>
          {comparePriceLists
            ? t('purchaseAgreements.priceList.closeComparison')
            : t('purchaseAgreements.priceList.comparePrices')}
        </OutlinedButton>
      </DialogTitle>

      <DialogContent className="padding-0" sx={{ display: 'flex' }}>
        <AgreementsWithPriceComparison
          assortmentId={assortmentId}
          supplierId={supplier.mgSupplierId}
          comparePriceLists={comparePriceLists}
        />
      </DialogContent>
    </Dialog>
  );
};

export default withDialogSuspenseErrorBoundary(SupplierAgreementsDialogContainer);
